import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { useGlobalLoading } from '../../../hooks/loadingHooks';
import { getI18nKeyOverrideForProductCard } from '../I18nUtils';
import { ProductCard } from '../cards/product-card/ProductCard';
import { ProductCards } from '../cards/product-card/ProductCards';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProductCardContainer = ({
  screen,
  productsToShow,
  trackingSource
}) => {
  const isAppReady = useGlobalLoading();
  if (!isAppReady) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      minHeight: 200,
      size: "md",
      grow: true
    });
  }
  return /*#__PURE__*/_jsx(ProductCards, {
    columns: productsToShow.length,
    children: productsToShow.map((apiName, index) => {
      const i18nKeys = getI18nKeyOverrideForProductCard(apiName);
      return /*#__PURE__*/_jsx(ProductCard, {
        apiName: apiName,
        columnStart: index + 1,
        screen: screen,
        trackingSource: trackingSource,
        title: i18nKeys === null || i18nKeys === void 0 ? void 0 : i18nKeys.title,
        description: i18nKeys === null || i18nKeys === void 0 ? void 0 : i18nKeys.description,
        skipInterstitialPage: ['core-seats-professional', 'core-seats-enterprise'].includes(apiName)
      }, apiName);
    })
  });
};